<template>
  <div class="wechat-sidebar-box">
      <div class="wechat-sidebar-content">
       <el-alert
          title="管理员可在企业微信管理后台“客户联系”-“效率工具”-“聊天侧边栏管理”中，将定制H5自建应用的页面配置到聊天侧边栏。"
          type="warning"
          show-icon>
        </el-alert>
         <div class="wechat-sidebar-item">
             <div class="wechat-sidebar-image">
               <img src="../../assets/images/ai-fuzhu.png" alt="">
             </div>
             <div class="wechat-sidebar-name">
                 客户详情
             </div>
             <div class="wechat-sidebar-desc">
                 通过企微侧边栏展示客户详细信息
             </div>
             <div class="wechat-sidebar-button">
               <el-button type="text">复制链接</el-button>
             </div>
         </div>
         <div class="wechat-sidebar-item">
             <div class="wechat-sidebar-image">
               <img src="../../assets/images/ai-fuzhu2.png" alt="">
             </div>
             <div class="wechat-sidebar-name">
                 沟通AI智能辅助
             </div>
             <div class="wechat-sidebar-desc">
                 AI可识别当前沟通内容，给出建议话术。
             </div>
             <div class="wechat-sidebar-button">
               <el-button type="text" @click="dialogVisible = true">配置</el-button>
             </div>
         </div>
      </div>
      <!-- 沟通辅助 -->
      <el-dialog
        title="沟通智能辅助配置"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="40%"
        :before-close="handleClose">
        <div class="config-content">
          <div class="step-item">
            <div class="label">
              <span>①</span>
              <span>选择AI智能辅助机器人，生成链接</span>
            </div>
            <div class="content">
              <el-select v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-button size="small" type="primary" icon="el-icon-refresh-right" style="margin-left:10px">立即生成</el-button>
            </div>
          </div>
          <div class="step-item">
            <div class="label">
              <span>②</span>
              <span>生成链接</span>
            </div>
            <div class="content">
              <div class="link">http://www.askbot.cn</div>
              <el-button type="text" style="margin-left:10px">copy</el-button>
            </div>
          </div>
          <div class="step-item">
            <div class="label">
              <span>③</span>
              <span>配置</span>
            </div>
            <div class="content">COPY链接，配置到企业微信中
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
export default {
  data(){
    return{
      dialogVisible: false,
      options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
      value: ''
    }
  }

}
</script>

<style lang="less" scoped>
@import url('../../assets/less/aiAssistant/wechatSidebar.less');
</style>>

</style>